'use strict';

var d3 = require('d3');
var _ = require('lodash');

/**
 *
 * @param d3Helper
 * @returns {Function}
 * @constructor
 */
var Curves = function Curves(d3Helper) {
  /**
   * The model object shall contain the following properties:
   *  - fill {String} - color of the curve
   *  - dotted {Boolean} - shall the curve be dotted
   *  - className {string} - css class for the curve
   *
   * @param xPropertyName - a property name used to find X value
   * @param yPropertyName - a property name used to find Y value
   * @param dataPropertyName - a property name used to find data collection
   * @param tooltipContentProvider - a function that should provide a content of a tooltip
   * @returns {Function}
   * @constructor
   */
  return function (xPropertyName, yPropertyName, dataPropertyName, curveInterpolation) {
    var params,
      scales,
      clipPath,
      discontinuous = false;
    function isDefined(d) {
      return d[yPropertyName] !== undefined && !isNaN(scales.xScale(d[xPropertyName]));
    }
    var curveFunction = d3.svg.line().defined(isDefined).x(function (d) {
      return scales.xScale(d[xPropertyName]);
    }).y(function (d) {
      return scales.yScale(d[yPropertyName]);
    }).interpolate(curveInterpolation || 'lineal');

    /**
     * In case if curve has points without data (base of function isDefined) curve will be split to couple of curves
     * @param {Array} data
     * @param objectDataName - a property name used to find data collection
     * @returns {Array}
     */
    function prepareDiscontinuousData(data, objectDataName) {
      return _.map(data, function (record) {
        var el = _.clone(record);
        el[objectDataName] = _.clone(record[objectDataName]);
        return el;
      });
    }

    /**
     *
     * @param container
     * @constructs Curves
     */
    var curveFunc = function curveFunc(container) {
      var shift = scales.xScale.rangeBand ? scales.xScale.rangeBand() / 2 : 0;
      var translate = [shift, 0];
      var group = d3Helper.createGroupElement(container, 'group-curves');
      if (clipPath) {
        group.attr('clip-path', clipPath);
      }
      var curves;
      var tmpDataPropertyName;
      var data;
      if (!dataPropertyName) {
        tmpDataPropertyName = 'curve-' + yPropertyName;
        data = [{}];
        data[0][tmpDataPropertyName] = container.datum();
      } else {
        data = container.datum();
      }
      if (discontinuous) {
        data = prepareDiscontinuousData(data, dataPropertyName || tmpDataPropertyName);
      }
      curves = group.selectAll('.curve-' + yPropertyName).data(data);
      curves.enter().append('path');
      curves.exit().remove();
      curves.attr('d', function (d) {
        return curveFunction(d[dataPropertyName || tmpDataPropertyName]);
      }).attr({
        'stroke-dasharray': function strokeDasharray(d) {
          return d.dotted ? d.customDash ? d.customDash : '3' : undefined;
        },
        'stroke': function stroke(d) {
          return d.fill;
        },
        'stroke-width': function strokeWidth(d) {
          return d.strokeWidth ? d.strokeWidth : '1.5';
        },
        'fill': 'none',
        'transform': 'translate(' + translate + ')',
        'class': function _class(d) {
          return 'curve ' + 'curve-' + yPropertyName + (d.className ? ' ' + d.className : '');
        }
      });
    };

    /**
     * Sets/gets curve's params
     * @param value
     * @returns {curveFunc}
     */
    curveFunc.params = function (value) {
      params = value;
      return curveFunc;
    };

    /**
     * Sets/gets curve's scales
     * @param value
     * @returns {curveFunc}
     */
    curveFunc.scales = function (value) {
      scales = value;
      return curveFunc;
    };
    curveFunc.discontinuous = function (value) {
      discontinuous = value;
      return curveFunc;
    };
    curveFunc.clipPath = function (value) {
      clipPath = 'url(' + value + ')';
      return curveFunc;
    };
    return curveFunc;
  };
};
Curves.$inject = ['d3Helper'];
module.exports = Curves;